<section id="origin" class="wrapper">
  <h3 class="title">{{ title }}</h3>

  <div *ngIf="cards.length && COMPONENTS">
    <div class="content-card-container">
      <div class="card" *ngFor="let cardBlok of cards | slice: 0:limit" [appStoryblokEditable]="cardBlok._editable">
        <ndc-dynamic [ndcDynamicComponent]="COMPONENTS[cardBlok.component]" [ndcDynamicInputs]="cardBlok">
        </ndc-dynamic>
      </div>
    </div>

    <div class="expander" *ngIf="isMobile && cards.length > NOT_EXPANDED_LIMIT">
      <button type="button" class="toggle" (click)="toggleExpanded()">
        {{ (isExpanded ? 'SHARED.SHOW_LESS.LABEL' : 'SHARED.SHOW_MORE.LABEL') | translate }}
      </button>

      <mat-icon *ngIf="!isExpanded">expand_more</mat-icon>
      <mat-icon *ngIf="isExpanded">expand_less</mat-icon>
    </div>
  </div>
</section>
